import e from"../localStorage.js";function t(t){return{exists:()=>!!e.get(t),get:function(){const r=e.get(t);return r?JSON.parse(r):null},set:r=>e.set(t,JSON.stringify(r)),delete:()=>e.delete(t)}}export{t as default};
